var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.64844 8.70902C9.77539 8.81059 9.77539 9.01371 9.64844 9.14062L6.70313 12.0859C6.57617 12.2129 6.39844 12.2129 6.27148 12.0859L3.32621 9.14062C3.19922 9.01371 3.19922 8.81059 3.32621 8.70902L3.50391 8.5059C3.6309 8.40434 3.80859 8.40434 3.93559 8.5059L6.06836 10.6387V1.11719C6.06836 0.939453 6.19531 0.8125 6.37305 0.8125H6.62695C6.7793 0.8125 6.93164 0.939453 6.93164 1.11719V10.6387L9.03906 8.5059C9.16602 8.40434 9.34375 8.40434 9.4707 8.5059L9.64844 8.70902Z",
    fill: "currentColor"
  })));
};
export default __webpack_public_path__ + "assets/fe192614d3477d823498b102402bc54e.svg";
export { SvgArrowDown as ReactComponent };


// WEBPACK FOOTER //
// ./assets/icons/arrow-down.svg